import React from 'react'
import styles from './CampoFecha.module.css'
import '@hassanmojab/react-modern-calendar-datepicker/lib/DatePicker.css';
import DatePicker, { utils } from "@hassanmojab/react-modern-calendar-datepicker"

/**
 * Componente CampoFecha.
 * @description componente que muestra un input de tipo fecha con la libreria @hassanmojab/react-modern-calendar-datepicker.
 */
const CampoFecha = ({ name, esObligatorio, valor, disabled, onChange, validacion, mensaje, edad }) => {
    
    const myCustomLocale = {
        // months list by order
        months: [
        'Enero',
        'Febrero',
        'Marzo',
        'Abril',
        'Mayo',
        'Junio',
        'Julio',
        'Agosto',
        'Setiembre',
        'Octubre',
        'Noviembre',
        'Diciembre',
        ],
      
        // week days by order
        weekDays: [
          {
            name: 'Domingo', // used for accessibility 
            short: 'D', // displayed at the top of days' rows
            isWeekend: true, // is it a formal weekend or not?
          },
          {
            name: 'Lunes',
            short: 'L',
          },
          {
            name: 'Martes',
            short: 'M',
          },
          {
            name: 'Miércoles',
            short: 'M',
          },
          {
            name: 'Jueves',
            short: 'J',
          },
          {
            name: 'Viernes',
            short: 'V',
          },
          {
            name: 'Sábado',
            short: 'S',
            isWeekend: true,
          }
        ],
      
        // just play around with this number between 0 and 6
        weekStartingIndex: 0,
      
        // return a { year: number, month: number, day: number } object
        getToday(gregorainTodayObject) {
          return gregorainTodayObject;
        },
      
        // return a native JavaScript date here
        toNativeDate(date) {
          return new Date(date.year, date.month - 1, date.day);
        },
      
        // return a number for date's month length
        getMonthLength(date) {
          return new Date(date.year, date.month, 0).getDate();
        },
      
        // return a transformed digit to your locale
        transformDigit(digit) {
          return digit;
        },
      
        // texts in the date picker
        nextMonth: 'Next Month',
        previousMonth: 'Previous Month',
        openMonthSelector: 'Open Month Selector',
        openYearSelector: 'Open Year Selector',
        closeMonthSelector: 'Close Month Selector',
        closeYearSelector: 'Close Year Selector',
        defaultPlaceholder: 'Select...',
      
        // for input range value
        from: 'from',
        to: 'to',
        // used for input value when multi dates are selected
        digitSeparator: ',',
      
        // if your provide -2 for example, year will be 2 digited
        yearLetterSkip: 0,
      
        // is your language rtl or ltr?
        isRtl: false,
    }
    
    const obtenerFormatoFecha = () => {
        if (!valor) return ''
        return `${valor.day}/${valor.month}/${valor.year}`
    }

    return (
        <div className={disabled ? styles.cajaDisa : styles.caja}>
            <label>{name}&nbsp;{esObligatorio ? "*" : null} </label>
            <DatePicker
                maximumDate={utils().getToday()}
                value={valor}
                onChange={(value) => onChange(value)}
                shouldHighlightWeekends
                colorPrimary="#0fbcf9"
                calendarClassName="responsive-calendar"
                calendarPopperPosition="bottom"
                inputPlaceholder="DD/MM/AAAA"
                formatInputText={obtenerFormatoFecha}
                locale={myCustomLocale}
            />
            {edad >= 0 ?
              (edad < 18 && (<span className={styles.mensajeValidacion}>{mensaje}</span>))
              : !validacion ? <span className={styles.mensajeValidacion}>{mensaje}</span> : null
            }
        </div>
    )
}

export default CampoFecha